import React, { useEffect, useState } from "react";
import { DialogActions } from "@material-ui/core";
import Swal from "sweetalert2";
import * as yup from "yup";
import AppForm from "../../../../../partials/content/Forms/AppForm";
import {
  getSafeStockItemDetail,
  saveSafeStockItemDetail,
} from "../../../../../services/inventory/safeStockService";
import SafeStockItemDetFormContent from "./SafeStockItemDetFormContent";
const safeStockSchema = yup.object().shape({
  data: yup.array().of(
    yup.object().shape({
      ID: yup.number(),
      qty: yup.number().min(1, "Quantity cannot be zero or empty"),
      requestQty: yup
        .number()
        .transform((value) => (isNaN(value) ? 0 : value))
        .nullable()
        .required("Quantity is required")
        .moreThan(0, "Quantity cannot be zero or empty")
        .default(0),
      uomName: yup.string().required("Unit is required"),
    })
  ),
});
function SafeStockItemDetailForm({
  safeStockID = 0,
  warehouseID = 0,
  outletID = 0,
  item = { itemID: 0, uomID: 0 },
  onCloseDialog,
  onConfirmSave,
}) {
  const [safeStockItemDetail, setSafeStockItemDetail] = useState({ data: [] });
  useEffect(() => {
    getSafeStockItemDetailData(safeStockID);
  }, [safeStockID]);
  async function getSafeStockItemDetailData(safeStockID = 0) {
    if (safeStockID > 0) {
      const response = await getSafeStockItemDetail(safeStockID);
      const { data } = response.data;
      setSafeStockItemDetail({ data: data.safeStockItemDetail });
    }
  }
  return (
    <AppForm
      initialValues={safeStockItemDetail}
      validationSchema={safeStockSchema}
      onSubmit={(values, { resetForm, setStatus, setSubmitting }) => {
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Safe Stock Item Detail ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              for (const stock of values.data) {
                stock.qty = parseFloat(stock.qty);
                stock.requestQty = parseFloat(stock.requestQty);
              }
              saveSafeStockItemDetail(values.data).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onConfirmSave();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      <SafeStockItemDetFormContent
        safeStockID={safeStockID}
        item={item}
        warehouseID={warehouseID}
        outletID={outletID}
      />
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={() => {
            onCloseDialog();
          }}
        >
          <i className="fas fa-window-close"></i>
          Close
        </button>
        <button
          type="submit"
          className="btn btn-success btn-md btn-pill btn-bold"
        >
          <i className="fas fa-save"></i>
          Save
        </button>
      </DialogActions>
    </AppForm>
  );
}

export default SafeStockItemDetailForm;
